import { PromotionalMessagesUI } from "./PromotionalMessagesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { useRouter } from "next/router";
import {
  promotionalMessagesToShow,
  usePreviousSaveMessaging,
} from "./promotionalMessagesUtils";

export function PromotionalMessages({
  product,
  configProps,
  experiences,
}: Pick<StandardProps, "product" | "configProps" | "experiences">) {
  const { query } = useRouter();
  const { variant } = useVariant(product);
  const messages = promotionalMessagesToShow(query, product, variant);

  const hidePromoDrawer =
    typeof configProps?.hidePromoDrawer == "boolean"
      ? configProps.hidePromoDrawer
      : false;

  const isPreviousSaveMessaging =
    experiences["previous-save-messaging"] === "on";

  const formattedMessages = usePreviousSaveMessaging(
    messages,
    isPreviousSaveMessaging,
  );

  return (
    <PromotionalMessagesUI
      promotionalMessages={formattedMessages}
      hidePromoDrawer={hidePromoDrawer}
    />
  );
}
